import type { ReactNode } from 'react';

import { usePermissions } from '@hooks/usePermissions';
import { Box, CircularProgress } from '@mui/material';
import { ForbiddenPage } from '@pages/ForbiddenPage';

import type { UtilityId } from './types';

interface RequireUtilityAccessProps {
  children: ReactNode;
  utilityId: UtilityId;
}

export const RequireUtilityAccess = ({ children, utilityId }: RequireUtilityAccessProps) => {
  const { hasAccess, isLoading } = usePermissions();

  if (isLoading) {
    return (
      <Box sx={{ alignItems: 'center', display: 'flex', height: '100vh', justifyContent: 'center' }}>
        <CircularProgress size={28} />
      </Box>
    );
  }

  if (!hasAccess(utilityId)) {
    return <ForbiddenPage />;
  }

  return <>{children}</>;
};
